import React from "react";
import * as styles from "./velavu-alert-modal-actions.module.scss";

export interface VelavuAlertModalActionsProps {
	children?: React.ReactNode;
}

export default function VelavuAlertModalActions(
	props: VelavuAlertModalActionsProps,
) {
	return <div className={styles.container}>{props.children}</div>;
}
